export default __webpack_public_path__ + "static/media/top-kukkel.4765036f.jpg";